import { useHasPermission } from "./useHasPermission";

// Renders children when the current user holds `permission` (any-of for an array).
// Otherwise renders `fallback`: nothing by default, a node, or a function that receives
// the children so a feature can show them in its own denied state (e.g. disabled).
//
// Use for JSX that is NOT a direct child of a react-router <Switch>; for routes, gate
// with the useHasPermission boolean instead (Switch matches on its direct <Route>s).
//
// Props:
//   permission: string | string[]
//   fallback: node | (children) => node
const PermissionGate = ({ permission, children, fallback = null }) => {
  if (useHasPermission(permission)) return children;
  return typeof fallback === "function" ? fallback(children) : fallback;
};

export default PermissionGate;
